<ul
  *ngIf="bookstoreAvailability && bookstoreAvailability.length > 0"
  class="list-unstyled u-mb0 left-right-list"
>
  <li
    *ngFor="let bookstore of bookstoreAvailability"
    class="left-right-list__entry"
  >
    <div class="bookstore-name">
      {{ bookstore.bookstore.label }}
    </div>

    <div class="bookstore-status">
      <!-- spin until resolved -->
      <span *ngIf="bookstore.availability?.isLoading === true">
        <i class="far fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
        <span class="sr-only" i18n="@@bookstoreAvailability-spinner-loading"
          >Loading...</span
        >
      </span>

      <!-- display a price and link if available -->
      <a
        class="btn btn-xs btn-default"
        *ngIf="
          bookstore.availability?.isLoading !== true &&
          bookstore.availability?.data?.detail_page_url
        "
        (click)="trackExternalLinkClick(bookstore)"
        [href]="bookstore.availability.data.detail_page_url"
        target="_blank"
        rel="noopener"
      >
        <span *ngIf="bookstore.availability.data.anyPrice">
          {{
            bookstore.availability.data.anyPrice
              | currency
                : bookstore.availability.data.currency || 'GBP'
                : 'symbol-narrow'
          }}
        </span>

        <span
          *ngIf="!bookstore.availability.data.anyPrice"
          i18n="@@bookstoreAvailability-btn-viewDetails"
        >
          View details
        </span>
      </a>

      <!-- display a placeholder when price is unavailable -->
      <span
        class="btn btn-xs btn-default disabled"
        *ngIf="
          !bookstore.availability ||
          (bookstore.availability?.isLoading !== true &&
            !bookstore.availability?.data?.detail_page_url) ||
          bookstore.availability.loadingError
        "
        i18n="@@bookstoreAvailability-error-unavailable"
      >
        Unavailable
      </span>
    </div>
  </li>
</ul>
